import { createStore } from 'vuex'

export interface AuthState {
  user: any | null
  token: string | null
}

export default createStore({
  state (): AuthState {
    return {
      user: null,
      token: localStorage.getItem('auth_token') || null // Initialize token from localStorage
    }
  },
  mutations: {
    setAuthData (state: AuthState, { user, token }: { user: any; token: string }) {
      state.user = user
      state.token = token
      localStorage.setItem('auth_token', token) // Persist the token in localStorage
    },
    clearAuthData (state: AuthState) {
      state.user = null
      state.token = null
      localStorage.removeItem('auth_token') // Remove the token from localStorage
    }
  },
  actions: {
    setAuthData ({ commit }, { user, token }: { user: any; token: string }) {
      commit('setAuthData', { user, token })
    },
    clearAuthData ({ commit }) {
      commit('clearAuthData')
    }
  },
  getters: {
    isAuthenticated (state: AuthState): boolean {
      return !!state.token
    },
    user (state: AuthState): any | null {
      return state.user
    },
    token (state: AuthState): string | null {
      return state.token
    }
  }
})
